'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'clock';
var width = 512;
var height = 512;
var aliases = [128339,"clock-four"];
var unicode = 'f017';
var svgPathData = ['M496 256a240 240 0 1 1 -480 0 240 240 0 1 1 480 0zM248 104l0 152c0 2.7 1.3 5.2 3.6 6.7l96 64c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1L264 251.7 264 104c0-4.4-3.6-8-8-8s-8 3.6-8 8z', 'M496 256a240 240 0 1 1 -480 0 240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM248 104l0 152c0 2.7 1.3 5.2 3.6 6.7l96 64c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1L264 251.7 264 104c0-4.4-3.6-8-8-8s-8 3.6-8 8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;